import React from "react";
import { Typography, Box, Container, Stack } from "@mui/material";
import "./index.css";
import CustomButton from "../generic-components/Button/Button";
import CheckIcon from "@mui/icons-material/Check";
import EastIcon from "@mui/icons-material/East";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useNavigate } from "react-router-dom";

const cardData = [
  {
    title: "Day to Day Bookkeeping",
    points: [
      "Accurate bank reconciliation",
      "Real-time financial reporting",
      "Accounts management",
    ],
    imageUrl: "/assets/card1.webp",
  },
  {
    title: "Payroll Services",
    points: [
      "Payroll processing & reporting",
      "Superannuation management",
      "STP & ATO compliance",
    ],
    imageUrl: "/assets/card2.webp",
  },
  {
    title: "BAS & GST Lodgements",
    points: [
      "Quarterly & BAS lodgement",
      "Calculation & reconciliation",
      "BAS agents support",
    ],
    imageUrl: "/assets/card3.webp",
  },
  {
    title: "Advisory & Compliance",
    points: [
      "Business structure advice",
      "Financial health checks",
      "ASIC & ATO compliance support",
    ],
    imageUrl: "/assets/card4.webp",
  },
];
const BookkeepingCard = ({ title, points, imageUrl }) => {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <Box
      className="card-container"
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <Box className="card-overlay">
        <Box>
          {points.map((point, i) => (
            <Typography className="card-point" key={i}>
              <CheckIcon fontSize="small" className="check-mark" />
              {point}
            </Typography>
          ))}
          <Typography className="card-title">{title}</Typography>
          <Box
            sx={{
              marginTop: { xs: 0, md: 5 },
              marginLeft: { xs: 0, md: 1 },
            }}
          >
            <CustomButton
              text="Book Now"
              className="book-now-btn"
              endIcon={<EastIcon className="arrow-icon" fontSize="small" />}
              onClick={() => handleNavigation("/book-now")}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const BookkeepingGrid = () => {
  const navigate = useNavigate();
  
  const handleNavigation = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3, mt: 0 }}>
      <Typography className="card-heading">
        Professional Bookkeeping & Business Advisory Services
      </Typography>
      <Typography className="card-description">
        End-to-end bookkeeping, payroll, and compliance solutions to help Australian businesses stay organised, ATO-compliant, and focused on growth.
      </Typography>

      <Stack
        direction="row"
        justifyContent="center"
        flexWrap="wrap"
        spacing={2}
        useFlexGap
        sx={{
          p: 0, // padding
          m: 0, // margin
        }}
      >
        {cardData.map((card, i) => (
          <Box key={i}>
            <BookkeepingCard {...card} />
          </Box>
        ))}
      </Stack>
      <Stack direction="row" justifyContent="center">
        <Box sx={{ marginTop: 5, alignItems: "center" }}>
          <CustomButton
            text="All Services"
            className="all-service-btn"
            startIcon={<FormatListBulletedIcon fontSize="small" />}
            onClick={() => handleNavigation("/services")}
          />
        </Box>
      </Stack>
    </Container>
  );
};

export default BookkeepingGrid;